module.exports = __webpack_public_path__ + "img/coins-solid.e4ab7881.svg";